import { Loader, EmptyComponent } from "processhub-components-lib";
import React, { useState, useEffect } from "react";
import KpiTab from "../../../DynamicWidgets/KpiTab";
import { KpiProps } from "./domain/types";

const Kpi: React.FC<KpiProps> = ({ tab, kpiConfig, hooks }) => {
  const { getTagData, getExpressionData } = kpiConfig;
  const { useData } = hooks;
  const { pastDate } = useData();

  const data = tab.configurations;

  const [kpiValues, setKpiValues] = useState<Record<string, any>>({});

  // Instead of hardcoding k1–k4, derive keys dynamically
  const kpiKeys = Object.keys(data) as Array<keyof typeof data>;

  const kpiData = kpiKeys.map((key) => ({
    id: data[key].id,
    name: data[key].name,
    type: data[key].type,
    value: kpiValues[data[key].id] ?? null,
  }));

  useEffect(() => {
    let isMounted = true;

    const fetchSequentially = async () => {
      for (const key of kpiKeys) {
        const { id, type } = data[key];
        if (!id) continue;

        try {
          const fetchFn = type === "tags" ? getTagData : getExpressionData;
          const res = await fetchFn([id], pastDate);

          if (isMounted && res.status === 200 && res.data.length > 0) {
            // update immediately after each fetch
            setKpiValues((prev) => ({ ...prev, [id]: res.data[0] }));
          }
        } catch (err) {
          console.error(`Failed to fetch KPI ${key.toString()}:`, err);
        }
      }
    };

    fetchSequentially();
    const intervalId = setInterval(fetchSequentially, 15000);

    return () => {
      isMounted = false;
      clearInterval(intervalId);
    };
  }, [tab, pastDate]);

  return (
    <>
      {!data && (
        <div className="w-full h-full grid place-content-center">
          <Loader />
        </div>
      )}
      <div className="grid grid-cols-2 grid-rows-2 gap-3 h-full">
        {kpiData.map(({ id, value, name }) =>
          id ? (
            <KpiTab key={id} data={value} name={name} />
          ) : (
            <EmptyComponent key={id} />
          )
        )}
      </div>
    </>
  );
};

export default React.memo(Kpi);
